<!-- -->
<template>
  <page pageDataUrl="/api/pageData/page_pg" v-on:paddingData="paddingPageData" :params="{type:  this.$route.params.type}"
    :hasbreadcrumbs="true" :breadcrumbs="breadcrumbs" :defPageTitle="pg.pGName">

    <div class='content'>
      <h1 class="entry-title">{{pg.pGName}}</h1>

        <div class="content-info">
          <h1>
            {{pg.pGFTitle}}
          </h1>
          <p>
            {{pg.pGRemark}}
          </p>
        </div>
      <div v-if="$route.params.type !== 'easy'">


        <div class="product-group">
          <div class="product-class-item" v-for="(item, index) in pg.ps" :key="index">
            <div class="top-ProductItem">
              <router-link :to="{path:'/units/'+pg.pGLink+'/'+item.pLink}">
                <h1>
                  {{item.pName}}
                </h1>
              </router-link>
              <h2>
                {{item.pFTitle}}
              </h2>
            </div>
            <p class="middle-productItem">
              {{item.pRemark}}
            </p>
            <img :src="item.pPic">
          </div>

        </div>
      </div>

      <div v-if="$route.params.type === 'easy'">

        <easySearch>

        </easySearch>

        <table class="easyTB temp03">
          <tbody>
            <tr>
              <th class="easyTBth01">密封方法</th>
              <th class="easyTBth02">分类</th>
              <th class="easyTBth03">机种</th>
            </tr>
            <tr v-for="(item, index) in ds" :key="index">
              <td class="easyTBcenter t-content" :rowspan="item.row === undefined? 0:item.row" v-if="item.frist">
                <img :src="pic" v-for="(pic, pi) in item.pics.src" style="margin-left: 10px;">
              </td>
              <td class="t-content" style="text-align: left;padding-left: 3px;">
                {{item.pGName}}
              </td>
              <td>
                <ul class="easyUl">
                  <li v-for="(p,pi) in item.ps">
                    <div class="t-content" style="text-align: left;padding-left: 3px;">
                      <router-link :to="{path:'/units/easy/'+p.pLink}" >
                        {{p.pName}}
                      </router-link>
                    </div>
                  </li>
                </ul>
              </td>
            </tr>

          </tbody>
        </table>

      </div>

    </div>
  </page>
</template>

<script>
  //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  //例如：import 《组件名称》 from '《组件路径》';

  export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
      //这里存放数据
      return {
        ds: [],
        pg: {},
        breadcrumbs: []
      };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
      paddingPageData(data) {
        this.pg = data.data;
        if (this.$route.params.type === "easy") {
          this.initDs(this.pg.pgs);
        }
        var bcs = [];
        bcs.push({
          path: "/units",
          name: "产品介绍"
        });
        this.breadcrumbs = bcs;
      },
      initDs(rs) {
        var list = [];
        if (rs !== undefined)
          for (var i = 0, len = rs.length; i < len; i++) {
            var df = rs[i];
            if (df.pgs === undefined || df.pgs.length === 0) {
              list.push({
                row: 1,
                pPgId: df.pGId,
                frist: true,
                pics: {
                  src: df.pGPic.split(","),
                  in: false
                }
              });
            } else {
              for (var j = 0, len2 = df.pgs.length; j < len2; j++) {
                var pg = df.pgs[j];
                if (j === 0) {
                  this.$set(pg, "pics", {
                    src: df.pGPic.split(",")
                  });
                  this.$set(pg, "frist", true);
                }
                this.$set(pg, "row", len2);
                list.push(pg);
              }
            }
          }
        this.ds = list;
      }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() { },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { } //如果页面有keep-alive缓存功能，这个函数会触发
  };
</script>
<style  scoped>
  .content-info {
    padding: 0 15px;
  }

  .content-info h1 {
    font-weight: bold;
    font-size: 110%;
    text-align: left;
    margin-bottom: 10px;
  }

  .content-info p {
    text-align: left;
    font-size: 95%;
    line-height: 1.6;
  }

  .entry-content table {
    border: 0;
    margin: 0;
  }

  .easyTB {
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;
    border-spacing: 0;
    empty-cells: show;
  }
  .entry-content table.temp03 th,
  table.temp03 th {
    line-height: 35px;
    height: 35px;
    border: #b0bec5 1px solid;
    font-size: 95%;
    letter-spacing: normal;
    background: #d6dae4;
    display: table-cell;
    text-align: center;
    color: #314478;
    font-weight: bold;
    vertical-align: middle;
  }

  .easyTB th.easyTBth01 {
    width: 40%;
  }

  .easyTB th.easyTBth02 {
    width: 20%;
  }

  .easyTB th.easyTBth03 {
    width: 260px;
  }

  .entry-content table.temp03 .easyTBcenter {
    text-align: center;
  }

  .entry-content table.temp03 td {
    padding: 5px;
    vertical-align: middle;
  }

  .entry-content table.temp03 td,
  table.temp03 td {
    border: #b0bec5 1px solid;
    font-size: 90%;
    letter-spacing: normal;
    display: table-cell;
    text-align: center;
    vertical-align: middle;
  }

  .entry-content table.temp03 td {
    padding: 5px;
    vertical-align: middle;
  }

  .entry-content table.easyTB td {
    text-align: left;
  }

  .easyUl li {
    line-height: 1.2;
    list-style-position: inside;
    word-break: keep-all;
    padding-top: 2px;
    padding-bottom: 2px;
  }

  .easyUl li a {
    color: #ff5900;
  }
</style>